import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    user_form_data: {},
    user_form_data_with_label: {},
    isPhoneNotEmptyAndCorrect: true,
    models: [],
    locations: [],
    lexicon: {}
  },
  mutations: {
    UPDATE_FORM_MODELS_CHOICES(state, payload) {
      state.models = payload
    },
  
    UPDATE_FORM_LOCATIONS_CHOICES(state, payload) {
      state.locations = payload
    },
    
    UPDATE_USER_FORM_DATA(state, payload) {
      Vue.set(state.user_form_data, 'input_' + payload.key,  payload.value)
      state.user_form_data['input_' + payload.key] = payload.value
    },
  
    UPDATE_USER_FORM_DATA_WITH_LABEL(state, payload) {
      Vue.set(state.user_form_data_with_label, 'input_' + payload.key,  payload.value)
      state.user_form_data_with_label['input_' + payload.key] = payload.value
    },
    
    DELETE_ATTRIBUTE_FORM_DATA(state, payload) {
      Vue.delete(state.user_form_data, payload)
    },
  
    UPDATE_PHONE_IS_CORRECT(state, payload) {
      state.isPhoneNotEmptyAndCorrect = payload
    },
    
    UPDATE_LEXICON(state, payload) {
      state.lexicon = payload
    }
  }
})


export default store
